import { createSelector } from 'reselect';
import FinancialAccountsWorkflow from '../FinancialAccountsWorkflow/FinancialAccountsWorkflowContainer';
import RetirementWorkflow from '../RetirementWorkflow/RetirementWorkflowContainer';
import EducationWorkflow from '../EducationWorkflow/EducationWorkflowContainer';
import HomePurchaseWorkflow from '../HomePurchaseWorkflow/HomePurchaseWorkflowContainer';
import DebtManagementWorkflow from '../DebtManagementWorkflow/DebtManagementWorkflowContainer';
import EmergencyFundWorkflow from '../EmergencyFundWorkflow/EmergencyFundWorkflowContainer';
import LargePurchaseWorkflow from '../LargePurchaseWorkflow/LargePurchaseWorkflowContainer';
import HealthCareWorkflow from '../HealthcareWorkflow/HealthcareWorkflowContainer';
import { DecumulationWorkflow } from '../DecumulationWorkflow/DecumulationWorkflow';

import { WORKFLOW_ID as FINANCIAL_ACCOUNTS_WORKFLOW_ID } from '../FinancialAccountsWorkflow/FinancialAccountsWorkflowConstants';
import { WORKFLOW_ID as RETIREMENT_WORKFLOW_ID } from '../RetirementWorkflow/RetirementWorkflowConstants';
import { WORKFLOW_ID as EDUCATION_WORKFLOW_ID } from '../EducationWorkflow/EducationWorkflowConstants';
import { WORKFLOW_ID as HOME_PURCHASE_WORKFLOW_ID } from '../HomePurchaseWorkflow/HomePurchaseWorkflowConstants';
import { WORKFLOW_ID as DEBT_MANAGEMENT_WORKFLOW_ID } from '../DebtManagementWorkflow/DebtManagementWorkflowConstants';
import { WORKFLOW_ID as EMERGENCY_FUND_WORKFLOW_ID } from '../EmergencyFundWorkflow/EmergencyFundWorkflowConstants';
import { WORKFLOW_ID as LARGE_PURCHASE_WORKFLOW_ID } from '../LargePurchaseWorkflow/LargePurchaseWorkflowConstants';
import { WORKFLOW_ID as HEALTHCARE_WORKFLOW_ID } from '../HealthcareWorkflow/HealthcareWorkflowConstants';
import { WORKFLOW_ID as DECUMULATION_WORKFLOW_ID } from '../DecumulationWorkflow/DecumulationWorkflow.constants';

const advWorkflowComponentSelector = createSelector(
  (_, { workflowId }) => workflowId,
  workflowId => {
    switch (workflowId) {
      case RETIREMENT_WORKFLOW_ID:
        return RetirementWorkflow;
      case EDUCATION_WORKFLOW_ID:
        return EducationWorkflow;
      case DEBT_MANAGEMENT_WORKFLOW_ID:
        return DebtManagementWorkflow;
      case HOME_PURCHASE_WORKFLOW_ID:
        return HomePurchaseWorkflow;
      case EMERGENCY_FUND_WORKFLOW_ID:
        return EmergencyFundWorkflow;
      case LARGE_PURCHASE_WORKFLOW_ID:
        return LargePurchaseWorkflow;
      case FINANCIAL_ACCOUNTS_WORKFLOW_ID:
        return FinancialAccountsWorkflow;
      case HEALTHCARE_WORKFLOW_ID:
        return HealthCareWorkflow;
      case DECUMULATION_WORKFLOW_ID:
        return DecumulationWorkflow;
      default:
        throw new Error('Invalid workflow ID');
    }
  },
);

export default advWorkflowComponentSelector;
